<template>
	<div class="barchart-wrapper">
		<div v-for="(category, index) in topCategories" :key="index" class="bar__item">
			<el-tooltip
				effect="dark"
				:content="category.category.number + ' ' + category.category.name"
				placement="top"
				:disabled="(category.category.number + ' ' + category.category.name).length <= 150"
				popper-class="tooltip--maxwidth"
			>
				<span class="bar__label"> {{ category.category.number + ' ' + category.category.name }}</span>
			</el-tooltip>

			<el-tooltip effect="dark" :content="getBarPercentage(category.count, totalCount)" placement="top">
				<div
					class="bar"
					:class="{ 'bar--empty': category.count === 0 }"
					:style="{ width: calculateBarWidth(category.count, totalCount) + 'px' }"
				></div>
			</el-tooltip>
			<span class="bar-info">{{ category.count }} von {{ totalCount }} {{ totalCountType }}</span>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
	name: 'CategoryBarChart',
	props: {
		categoryData: {
			type: Array as PropType<{ category: { number: string; name: string }; count: number }[]>,
			required: true,
		},
		totalCount: {
			type: Number as PropType<number>,
			required: false,
			default: 0,
		},
		totalCountType: {
			type: String,
			default: 'Werberäten',
		},
	},
	computed: {
		topCategories() {
			const sortedCategories = this.categoryData.sort((a, b) => b.count - a.count).slice(0, 10);
			const maxCount = Math.max(...sortedCategories.map((item) => item.count), 1); // Mindestens 1, um Division durch 0 zu vermeiden

			return sortedCategories.map((item) => ({
				...item,
				percentage: (item.count / maxCount) * 100,
			}));
		},
		totalDecisions() {
			return this.categoryData.reduce((sum, item) => sum + item.count, 0);
		},
	},
	methods: {
		truncateLabel(label: string) {
			return label.length > 150 ? label.slice(0, 147) + '...' : label;
		},

		calculateBarWidth(count: number, maxCount: number) {
			// Basis width is 750px
			// Für Elemente mit count 0 einen fixen Minimalwert zurückgeben
			if (count === 0) {
				return 10;
			}
			return (count / maxCount) * 750;
		},
		getBarPercentage(count: number, maxCount: number) {
			if (count === 0) {
				return '0%';
			}
			return Number(((count / maxCount) * 100).toFixed(2)).toString() + '%';
		},
	},
});
</script>